import { render, staticRenderFns } from "./Acessos.vue?vue&type=template&id=4a8d7a07&scoped=true"
import script from "./Acessos.vue?vue&type=script&lang=js"
export * from "./Acessos.vue?vue&type=script&lang=js"
import style0 from "./Acessos.vue?vue&type=style&index=0&id=4a8d7a07&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8d7a07",
  null
  
)

export default component.exports